<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e31"><b>OTHERS BOOKS BY JONI EARECKSON TADA</b></p>
<p class="extc" id="d12e34"><i>How to Be a Christian in a Brave New World </i><br/>(with Nigel M. de S. Cameron) <br/><i>The God I Love </i><br/><i>Diamonds in the Dust </i><br/><i>More Precious Than Silver </i><br/><i>Heaven </i><br/><i>When God Weeps </i>(with Steve Estes) <br/><i>Joni </i>(with Joe Musser) <br/><i>A Step Further </i>(with Steve Estes) <br/><i>All God’s Children </i>(with Gene Newman) <br/><i>Barrier-Free Friendships </i>(with Steve Jensen) <br/><i>The Life and Death Dilemma</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tada_9780310297864_epub_c2_r1.vue?369bfafe